module.exports = __webpack_public_path__ + "img/all-sports-dark.ed54f43c.svg";